import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {useStableRandom} from '@github-ui/use-stable-random'
import {clsx} from 'clsx'

import {TEST_IDS} from '../constants/test-ids'
import {CommentDivider} from './CommentDivider'
import styles from './CommentLoading.module.css'

type CommentLoadingProps = {
  inHighlightedTimeline?: boolean
}

export const CommentLoading = ({inHighlightedTimeline}: CommentLoadingProps) => {
  const lineCount = useStableRandom({min: 1, max: 6})

  return (
    <div className={styles.CommentLoadingContainer}>
      <LoadingSkeleton
        variant="elliptical"
        height="40px"
        width="40px"
        className={clsx(styles.avatarSkeleton, inHighlightedTimeline && styles.avatarSkeletonHiddenSmall)}
      />
      <div className={styles.CommentLoadingContentWrapper}>
        <CommentDivider />
        <div data-testid={TEST_IDS.commentSkeleton} className={styles.CommentLoadingCard}>
          <div className={styles.CommentLoadingHeader}>
            <LoadingSkeleton variant="rounded" height="sm" width="150px" />
          </div>
          <div className={styles.CommentLoadingContent}>
            {[...Array(lineCount)].map((_, index) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <LoadingSkeleton key={index} variant="rounded" height="sm" width="random" />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
